import { render, staticRenderFns } from "./Constantes.vue?vue&type=template&id=c20df1f8"
import script from "./Constantes.vue?vue&type=script&lang=js"
export * from "./Constantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports